import { Css } from "@homebound/beam";

export const richTextScroll = "truss-rtc";
export const richTextMinHeight = "truss-rtmh";

/** Using css to adjust default height of BoundRichTextField and provide vertical scroll bar when needed. */
export const css = {
  [`.${richTextScroll} [role="textbox"], .${richTextScroll} [data-readonly="true"]`]: Css.raw`
    max-height: 320px;
    overflow-y: auto;
  `,
  [`.${richTextMinHeight} [role="textbox"]`]: Css.raw`
    min-height: 40px;
  `,
};
